import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactCodeInput from 'react-verification-code-input';
import { Box, useTheme } from '@mui/material';
export var DigitalCodeInput = function(param) {
    var isVerifying = param.isVerifying, handleVerifyCode = param.handleVerifyCode;
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            '& .code-input-ctn': {
                maxWidth: 200,
                margin: 'auto'
            }
        },
        children: /*#__PURE__*/ _jsx(Box, {
            sx: {
                '.code-input-ctn': {
                    width: '100% !important',
                    div: {
                        display: 'flex',
                        columnGap: 1,
                        input: {
                            flexBasis: 0,
                            flexGrow: 1,
                            borderRadius: '4px',
                            fontFamily: 'inherit',
                            width: '100% !important',
                            caretColor: 'currentColor',
                            border: "solid 3px ".concat(theme.palette.primary.light),
                            '&:focus': {
                                border: "solid 3px ".concat(theme.palette.primary.main)
                            },
                            '&:focus + input': {
                                borderLeft: "solid 3px ".concat(theme.palette.primary.light)
                            }
                        }
                    },
                    'div[class*="styles_loading"]': {
                        height: '54px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }
                }
            },
            children: /*#__PURE__*/ _jsx(ReactCodeInput, {
                autoFocus: true,
                className: "code-input-ctn",
                loading: isVerifying,
                onComplete: handleVerifyCode,
                fields: 4
            })
        })
    });
};
